import { render, staticRenderFns } from "./ItemMenuList.vue?vue&type=template&id=d17824d0&scoped=true&"
import script from "./ItemMenuList.vue?vue&type=script&lang=js&"
export * from "./ItemMenuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17824d0",
  null
  
)

export default component.exports